export default __webpack_public_path__ + "static/media/dp2.5d4ab0c0.svg";